import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";

const AlbumGallery = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { album } = location.state || { album: { title: "", data: [] } };

  const [show, setShow] = useState(false);
  const [modalMedia, setModalMedia] = useState(null);

  const handleShow = (media) => {
    setModalMedia(media);
    setShow(true);
  };

  const handleClose = () => {
    setModalMedia(null);
    setShow(false);
  };

  return (
    <div className="bg-white" style={{ height: "85vh", overflowY: "auto" }}>
      <div className="p-3">
        <h3 className="text-center mb-5 ">{album?.title}</h3>
        {/* <div className="d-flex justify-content-end mb-3">
        <button
          className="btn btn-sm btn-secondary"
          onClick={() => navigate(-1)}
        >
          <i className="bx bx-left-arrow-alt"></i> Back
        </button>
      </div> */}
        <div className="row">
          {album?.data?.map((item, index) => (
            <div key={index} className="col-md-4 col-lg-3 mb-4">
              <div
                className="gallery-card border rounded shadow-lg"
                style={{ cursor: "pointer" }}
                onClick={() => handleShow(item)}
              >
                {item.extension_type === "image" && (
                  <img
                    src={item.file_url.replace("/thumb", "")}
                    alt="Gallery"
                    className="media-content img-fluid"
                    style={{
                      height: "200px",
                      objectFit: "cover",
                      width: "100%",
                    }}
                  />
                )}
                {item.extension_type === "video" && (
                  <video
                    src={item.file_url}
                    className="media-content img-fluid"
                    style={{
                      height: "200px",
                      objectFit: "cover",
                      width: "100%",
                    }}
                    muted
                  ></video>
                )}
                {item.extension_type === "audio" && (
                  <div
                    className="d-flex align-items-center justify-content-center bg-light"
                    style={{ height: "200px" }}
                  >
                    <i
                      className="bi bi-music-note"
                      style={{ fontSize: "2rem" }}
                    ></i>
                  </div>
                )}
              </div>
            </div>
          ))}
          
        </div>
      </div>

      {/* Modal */}
      <Modal show={show} onHide={handleClose} centered size="md">
        <Modal.Header closeButton>
          <Modal.Title>Media Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {modalMedia?.extension_type === "image" && (
            <img
              src={modalMedia.file_url.replace("/thumb", "")}
              alt="Modal"
              className="img-fluid w-100"
            />
          )}
          {modalMedia?.extension_type === "video" && (
            <video src={modalMedia.file_url} controls className="img-fluid" />
          )}
          {modalMedia?.extension_type === "audio" && (
            <audio controls className="w-100">
              <source src={modalMedia.file_url} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AlbumGallery;
